import dayjs from "dayjs/esm";
import "dayjs/esm/locale/fr";
import {debounce, getAsync} from "./utils";
import {
  prevTimeline,
  prevStepTimeline,
  nextTimeline,
  nextStepTimeline,
  toggleTimeline,
  refreshTimeline,
  scaleTimelineSlider,
  initTimelineSlider, updateTimelineDatetime
} from "./timeline";
import {
  toggleLayer,
  geolocateMe, webcamDetails, refreshWindSensorsData
} from "./data";
import {toggleMap} from "./map";
import {displaySensorCharts} from "./sensor";
import {
  updateLayout,
  sliderDisplay,
  initSlides,
  createSlides,
  displayNews,
  timeline,
  map,
  isSpotContext, isEditMode, currentActiveSpot, displayWindFranceForm
} from "./common";
import {advertisersRefs, config} from "./config";
import router from "./router";
import MicroModal from "micromodal";
import {closePoi, removeActivePoi, setFavorite} from "./meteogramme";
import weatherIcons from "../img/weather/*.svg";
import {
  applySpotTemplate,
  cancelEditSpot,
  configureDemoSpot,
  configureSpot,
  configureSpots,
  createAccount,
  createMockAccount,
  createWindSession,
  dismissAccountCreation,
  mockSignIn,
  resetPassword,
  saveCurrentSpot,
  showSpot,
  showSpotsTemplates,
  startSpotsTour, submitPasswordReset,
  toggleAccountSpots,
  toggleSpotTemplate,
  validateUserProfile
} from "./account";
// import * as Sentry from "@sentry/browser";
// import {Integrations} from "@sentry/tracing";

// Sentry.init({
//   dsn: "https://226f2354cdc842db97ac896999739be9@o21346.ingest.sentry.io/5807697",
//   integrations: [new Integrations.BrowserTracing()],
//   tracesSampleRate: 0.5
// });

dayjs.locale('fr');

// console.timeLog('trace', 'main.js start');

document.addEventListener("DOMContentLoaded", function (evt) {
  // document.querySelector("#toggle_map_menu").addEventListener("click", function(evt) {
  //   toggleMapNav();
  // });
  // console.time('initSlides');
  initSlides(function () {
    // console.timeLog('initSlides', 'p1')
    createSlides(advertisersRefs, "partners")
    // console.timeLog('initSlides', 'p2')
    sliderDisplay("partners");
    // console.timeEnd('initSlides');
    loadMenuLinks();
  });
  window.wm = {
    toggleLayer,
    toggleMap,
    toggleSideNav,
    toggleAccountSpots,
    displayWindFranceForm,
    showSpot,
    configureSpots,
    configureSpot,
    configureDemoSpot,
    saveCurrentSpot,
    cancelEditSpot,
    showSpotsTemplates,
    toggleSpotTemplate,
    applySpotTemplate,
    createAccount,
    createMockAccount,
    dismissAccountCreation,
    mockSignIn,
    createWindSession,
    resetPassword,
    submitPasswordReset,
    validateUserProfile,
    startSpotsTour,
    isSpotContext,
    isEditMode,
    openTab,
    geolocateMe,
    prevTimeline,
    prevStepTimeline,
    nextTimeline,
    nextStepTimeline,
    toggleTimeline,
    refreshTimeline,
    toggleLines,
    displaySensorCharts,
    refreshWindSensorsData,
    setFavorite,
    goToFavorite,
    closePoi,
    displayNews,
    toggleMotivations,
    displaySignInForm,
    displaySignUpForm,
    showModal,
    dismissModal,
    webcamDetails,
    dumpCurrentSpot,
    scrollToElement
  };
});

var windowResized = debounce(function () {
  window.location.reload();
}, 800);
// window.onresize = windowResized;

function toggleSideNav(btn, forceClose) {
  if (forceClose) {
    btn.classList.remove('active');
  } else {
    btn.classList.toggle('active');
  }
}

function openTab(btn) {
  document.querySelector("#side_tabs .active").classList.remove("active");
  btn.classList.add('active');
  btn.parentElement.setAttribute('data-active', btn.getAttribute('data-tab'));
}

function loadMenuLinks() {
  const tld = window.location.hostname.split('.').slice(-2, -1)[0] || 'localhost';

  getAsync(`${config.backEndUrl}/menus/${tld}.json`, function(menus) {
    let menuLinksWrapper, menuHtml, menuContent;
    for (const m in menus) {
      menuLinksWrapper = document.querySelector(`#side_menu [data-links='${m}']`);
      menuContent = menus[m];
      if (menuLinksWrapper && menuContent.links_by_section) {
        menuHtml = '<div>';
        for (const s in menuContent.links_by_section) {
          menuHtml += `<h3>${s}</h3>`;
          for (const l of menuContent.links_by_section[s]) {
            menuHtml += `<a href="${l.link_url}" target="_blank"><img alt="${l.title}" class="image-thumbnail" src="${l.image_url}"><span>${l.title}</span></a>`;
          }
        }
        menuHtml += '</div>';
        menuLinksWrapper.innerHTML = menuHtml;
      }
    }
  });
}

function toggleLines(btn, ...cls) {
  let c, line;
  for (c of cls) {
    let lines = Array.from(document.querySelectorAll("#weather_details_header ." + c + ", #weather_details ." + c));
    for (line of lines) {
      if (line.style.display === "none") {
        line.style.display = "flex";
      } else {
        line.style.display = "none";
      }
    }
  }
  btn.classList.toggle('active');
}


function favoriteDetails() {
  removeActivePoi();
  document.querySelector("#map_modal").setAttribute("data-modal", "favorite");
  document.querySelector("#map_modal_title").innerHTML = "Définir son plan d’eau favori";
  document.querySelector("#header_links").innerHTML = '<button class="modal__close" aria-label="Fermer" data-micromodal-close></button>';
  document.querySelector("#map_modal_content").innerHTML =
    '<div>Cliquez sur le pictogramme météo <img class="img-icon" src="' + weatherIcons["soleil"] + '" alt="Soleil">  de votre choix. Puis cliquez sur le bouton « Définir comme favori »</div>';
  MicroModal.show('map_modal', {
    disableScroll: true, onClose: () => {
      console.debug('favoriteDetails');
      router.navigate("/");
    }
  });
}

function goToFavorite() {
  const path = config.favoritePath;
  if (path) {
    router.navigate(path);
  } else {
    var menuBtn = document.querySelector("#weather_fc");
    if (!menuBtn.classList.contains("active")) {
      wm.toggleLayer(menuBtn, 'weather_fc');
    }
    favoriteDetails();
  }
  toggleSideNav(document.querySelector("#toggle_side_menu"), true);
}

function toggleMotivations(elt) {
  elt.parentElement.classList.toggle('expanded');
  scrollToElement("#motivation_wrapper");
}

function displaySignUpForm(btn) {
  if (btn.parentElement.querySelector("button.active")) {
    btn.parentElement.querySelector("button.active").classList.remove('active');
  }
  btn.classList.add('active');
  document.querySelector("h3.motivation_toggle").classList.remove('expanded');
  document.querySelector("#wm_sign_up_form").classList.remove('hidden');
  document.querySelector("#wm_sign_in_form").classList.add('hidden');
  validateUserProfile();
  scrollToElement("#wm_sign_up_form");
}

function displaySignInForm(btn) {
  if (btn.parentElement.querySelector("button.active")) {
    btn.parentElement.querySelector("button.active").classList.remove('active');
  }
  btn.classList.add('active');
  document.querySelector("h3.motivation_toggle").classList.remove('expanded');
  document.querySelector("#wm_sign_up_form").classList.add('hidden');
  document.querySelector("#wm_sign_in_form").classList.remove('hidden');
  scrollToElement("#wm_sign_in_form");
}

function showModal(modalId) {
  MicroModal.show(modalId, {disableScroll: true});
}

function dismissModal(modalId) {
  MicroModal.close(modalId);
}

function dumpCurrentSpot() {
  console.debug("Spot courant : \n\n" + JSON.stringify(currentActiveSpot()));
}

function scrollToElement(selector) {
  let elt = document.querySelector(selector);
  if (elt) {
    elt.scrollIntoView({block: "start", inline: "nearest", behavior: "smooth"});
  }
}

// console.timeLog('trace', 'fin main.js');

